import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        stack: {
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: ['small.lg', 'medium.base', 'medium.sm', 'medium.md'],
            alignSelf: 'strech',
            width: '100%',
        },
        stackItem: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        textContainer: {
            display: 'flex',
            flexDir: 'row',
            gap: 2,
            color: 'text.default',
            textAlign: 'center',
            textStyle: 'body-small',
            fontWeight: 400,
            paddingTop: remCalc(4),
            marginRight: remCalc(10),
        },
        stackText: {
            color: 'text.default',
        },
        filterHit: {
            color: 'text.secondary',
        },
    },
}
